// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3h7Vh","leftWrapper":"_3UjVf","heading":"_3GNZ1","subHeading":"_3N5Ou","rightWrapper":"_1fjod"};